import { render, staticRenderFns } from "./ProjectIrrigationBoreHole.vue?vue&type=template&id=0f5857dd"
import script from "./ProjectIrrigationBoreHole.vue?vue&type=script&lang=js"
export * from "./ProjectIrrigationBoreHole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports